export enum ContactType {
  TechnicalSupport = 'TECHNICAL_SUPPORT',
  AccountManager = 'ACCOUNT_MANAGER',
  Sales = 'SALES',
}
